import { createHostModule } from '@wix/sdk-runtime/host-modules';
import type { AuthenticationStrategy } from '@wix/sdk-types';
import { createSDKBuilders } from './sdk';
import type { CreateHost, Host, SDK } from './types';

export const createDashboardModule = ({
  createHost,
}: {
  createHost: CreateHost;
}) => {
  const dashboardSDKBuilders = createSDKBuilders();
  return {
    ...createHostModule<Host, SDK>(dashboardSDKBuilders),
    host: createHost,
    auth: () => {
      return {
        getAuthHeaders: async (host) => {
          const getAccessToken = dashboardSDKBuilders.getAccessToken(host);
          return {
            headers: {
              Authorization: await getAccessToken(),
            },
          };
        },
      } as AuthenticationStrategy<Host>;
    },
  };
};
